"use strict";

var isArray = Array.isArray;
module.exports = isArray;